export const getInputStyle = (theme) => ({
    width: "100%",
    padding: "10px 14px",
    borderRadius: "10px",
    border: theme === "dark" ? "1px solid rgba(255,255,255,0.15)" : "1px solid #d1d5db",
    background: theme === "dark" ? "rgba(255,255,255,0.06)" : "#fff",
    color: theme === "dark" ? "#fff" : "#111827",
    fontSize: "14px",
    outline: "none",
    boxSizing: "border-box",
});

export const getCardStyle = (theme) => ({
    background: theme === "dark" ? "rgba(30,41,59,0.9)" : "#fff",
    border: theme === "dark" ? "1px solid rgba(255,255,255,0.1)" : "1px solid #e5e7eb",
    borderRadius: "20px",
    padding: "36px",
    maxWidth: "820px",
    margin: "0 auto",
});

export const getTitleStyle = (theme) => ({
    fontSize: "22px",
    fontWeight: "700",
    color: theme === "dark" ? "#fff" : "#111827",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    margin: "0 0 8px 0",
});

export const getSubtitleStyle = (theme) => ({
    fontSize: "14px",
    color: theme === "dark" ? "rgba(255,255,255,0.6)" : "#6b7280",
    margin: "0 0 24px 0",
});

export const getHintStyle = (theme) => ({
    fontSize: "13px",
    color: theme === "dark" ? "rgba(255,255,255,0.5)" : "#9ca3af",
    margin: "8px 0 20px 0",
    padding: "10px 14px",
    background: theme === "dark" ? "rgba(255,255,255,0.04)" : "#f9fafb",
    borderRadius: "8px",
    border: theme === "dark" ? "1px solid rgba(255,255,255,0.08)" : "1px solid #e5e7eb",
});

export const getSubmitButtonStyle = (saving, loadingCompanies) => ({
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 28px",
    background: saving || loadingCompanies ? "#93c5fd" : "#2e7cba",
    color: "#fff",
    border: "none",
    borderRadius: "12px",
    fontSize: "15px",
    fontWeight: "700",
    cursor: saving || loadingCompanies ? "not-allowed" : "pointer",
    transition: "background 0.2s ease",
});

export const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(min(320px, 100%), 1fr))",
    gap: "20px",
    marginBottom: "24px",
};

export const labelStyle = {
    display: "block",
    fontSize: "13px",
    fontWeight: "600",
    color: "#374151",
    marginBottom: "6px",
};

export const getMessageStyle = (type) => ({
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "12px 16px",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: "500",
    marginBottom: "20px",
    background:
        type === "success"
            ? "rgba(16,185,129,0.12)"
            : type === "error"
            ? "rgba(239,68,68,0.12)"
            : "rgba(245,158,11,0.12)",
    color:
        type === "success"
            ? "#059669"
            : type === "error"
            ? "#dc2626"
            : "#d97706",
    border: `1px solid ${
        type === "success"
            ? "rgba(16,185,129,0.3)"
            : type === "error"
            ? "rgba(239,68,68,0.3)"
            : "rgba(245,158,11,0.3)"
    }`,
});